import React from "react";
import styles from "./style.module.scss";
import clsx from "clsx";
import { primary, secondary } from "@/hooks/useFonts";

type Props = {
  children?: React.ReactNode;
  component?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "p" | "span";
  variant?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "p" | "span";
  color?: "blue" | "white";
  size?: "sm" | "md" | "lg" | "xl";
  family?: "primary" | "secondary";
  className?: string;
  uppercase?: boolean;
};
export default function Title({
  children,
  component = "span",
  color = "blue",
  size = "md",
  className,
  family = "secondary",
  variant,
  uppercase = true,
}: Props) {
  const Component = component;
  return (
    <Component
      className={clsx(
        styles.title,
        styles[variant ? variant : component],
        family == "secondary" ? secondary : primary,
        `color-${color}`,
        styles[size],
        className,
        uppercase ? "uppercase" : ""
      )}
    >
      {children}
    </Component>
  );
}
